import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {history} from '../../../store';

class UniqueButton extends Component {
  state = {
    hover: false
  };

  baseButtonStyle = {
    fontSize: '15px',
    lineHeight: '1.7',
    boxSizing: 'border-box',
    padding: '2px 18px',
    borderRadius: '0',
    textTransform: 'uppercase',
    display: 'inline-block',
    margin: '0 2px 3px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '100%',
  };

  getButtonStyle = () => {
    const { buttonColor, buttonTextColorWhenHover } = this.props;
    const { hover } = this.state;
    const hoveredButtonStyle = {
      color: buttonTextColorWhenHover,
      backgroundColor: buttonColor,
      borderColor: buttonColor,
    };
    const transparentButtonStyle = {
      color: buttonColor,
      backgroundColor: 'transparent',
      borderColor: buttonColor,
    };
    return hover ? {...this.baseButtonStyle, ...hoveredButtonStyle} : {...this.baseButtonStyle, ...transparentButtonStyle};
  };

  hoverOn = () => {
    this.setState({hover: true});
  };

  hoverOff = () => {
    this.setState({hover: false});
  };

  render() {
    const { buttonLabel, buttonLink } = this.props;
    return (
      <Button
        onMouseEnter={this.hoverOn}
        onMouseLeave={this.hoverOff}
        style={this.getButtonStyle()}
        onClick={() => {
          if (buttonLink.match(/^https?:.*/i)) {
            window.open(buttonLink, '_blank');
          } else {
            history.push(buttonLink);
          }
        }}
      >
        {buttonLabel}
      </Button>
    );
  }
}

export default UniqueButton;



// WEBPACK FOOTER //
// ./src/components/common/home/uniqueButton.jsx